import { useCallback, useState } from 'react';

import type { Station } from '../types/station';

export const useSelectedStation = () => {
  const [selectedStation, setSelectedStation] = useState<Station | null>(null);

  const selectStation = useCallback((station: Station) => {
    setSelectedStation(station);
  }, []);

  const deselectStation = useCallback(() => {
    setSelectedStation(null);
  }, []);

  return { selectedStation, selectStation, deselectStation };
};